import { Loader } from '@googlemaps/js-api-loader';

export const Maps = () => {
	// Set our map div from the DOM
	const mapElements = document.querySelectorAll('.js-map');

	// Check for our map instances
	if (mapElements.length) {
		// Set our API key from our ENV
		const loader = new Loader({
			apiKey: process.env.MIX_GOOGLE_MAPS_API
		});

		// Loop over our map instances
		mapElements.forEach((mapElement) => {

			// Setup the map options
			const mapInstance = {
				element: mapElement,
				options: {
					center: {
						lat: mapElement.dataset.lat ? parseFloat(mapElement.dataset.lat) : 0,
						lng: mapElement.dataset.lng ? parseFloat(mapElement.dataset.lng) : 0,
					},
					zoom: 17,
				}
			}

			loader
				.load()
				.then((google) => {
					// Create a new map
					const googleMap = new google.maps.Map(mapInstance.element, mapInstance.options);

					// Create a new pin on our map
					new google.maps.Marker({
						position: { 
							lat: mapInstance.options.center.lat, 
							lng: mapInstance.options.center.lng 
						},
						map: googleMap
					})
				})
				.catch((e) => {
					console.log(e);
				});
		});
	}
}